import {useAuth} from 'app/modules/auth'
import Iconize from 'app/shared/Alfacom/Icon/Iconize'
import UserSymbol from 'app/shared/Alfacom/Symbol/UserSymbol'
import {GetModuleColor, GetModuleIcon, GetModulePath, Module} from 'app/shared/Common/Enums'
import clsx from 'clsx'
import React, {FC, useState} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {useListener} from 'react-bus'
import {EVENT_EMITTER} from 'app/shared/Common/Constants'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const {currentUser, logout} = useAuth()
  const {config} = useLayout()
  const {pathname} = useLocation()
  const [unreadNotification, setUnreadNotification] = useState<number>()

  useListener(EVENT_EMITTER.NOTIFICATION.UNREAD_NOTIFICATION.UNREAD_NOTIFICATION_COUNT, (count) => {
    setUnreadNotification(count)
  })

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* USER */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)} id='kt_header_user_menu_toggle'>
        <div
          className={clsx(
            `btn btn-icon btn-active-light-${GetModuleColor(Module.Profile)} btn-custom position-relative`,
            toolbarUserAvatarHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <Iconize biIcon={`fs-1 ${GetModuleIcon(Module.Profile)}`} position='icon-only' />
        </div>
        <HeaderUserMenu />
      </div>

      {/* NOTIFICATIONS */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <div
          className={clsx(`btn btn-icon btn-active-light-${GetModuleColor(Module.Notification)} btn-custom position-relative`)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <Iconize biIcon={`fs-1 ${GetModuleIcon(Module.Notification)}`} position='icon-only' />
          {unreadNotification != 0 && (
            <span className='bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink'></span>
          )}
        </div>
        <HeaderNotificationsMenu />
      </div>

      {/* LOG OFF */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
        <a
          href={''}
          onClick={(e) => {
            e.preventDefault()
            logout()
          }}
          className={clsx(`btn btn-icon btn-active-light-${GetModuleColor(Module.Logout)} btn-custom position-relative`)}
        >
          <Iconize biIcon={`fs-1 ${GetModuleIcon(Module.Logout)}`} position='icon-only' />
        </a>
        {/* end::Menu wrapper */}
      </div>
    </div>
  )
}

export {Topbar}
